// eslint-disable-next-line
export enum LocalStorageKeysEnum {
    PHARMACEUTICAL_CRFUF_LOGIN = 'PHARMACEUTICAL_CRFUF_LOGIN',
    FIND_ALL_MEDICINES_DATA = 'FIND_ALL_MEDICINES_DATA',
    CEP_INTEGRATION = 'CEP_INTEGRATION',
    PHARMACEUTICAL_DATA = 'PHARMACEUTICAL_DATA',
    PHARMACEUTICAL_CREDENTIALS = 'PHARMACEUTICAL_CREDENTIALS',
    FIND_DISCOUNTS_BY_PATIENT = 'FIND_DISCOUNTS_BY_PATIENT',
    FIND_PRODUCTS_AVAILABLE_TO_DISCOUNTS = 'FIND_AVAILABLE_PRODUCTS_TO_DISCOUNTS',
    PHARMACEUTICAL_CPF_LOGIN = 'PHARMACEUTICAL_CPF_LOGIN',
    FIND_PROFESSIONAL_TYPES = 'FIND_PROFESSIONAL_TYPES',
    FIND_CRM_PRODUCTS = 'FIND_CRM_PRODUCTS',
    FIND_PROFESSIONALS = 'FIND_PROFESSIONALS',
    FIND_SCHEDULES_BY_PATIENT_FOLLOWUP = 'FIND_SCHEDULES_BY_PATIENT_FOLLOWUP',
    GET_SCHEDULE = 'GET_SCHEDULE',
    SURVEY_PARAMETERS = 'SURVEY_PARAMETERS',
    GET_TAGS = 'GET_TAGS',
    GET_POSTS = 'GET_POSTS',
    GET_CONTENTS = 'GET_CONTENTS',
}
